// Rendert Standortnamen mit dem echten Tipwin-Logo statt des Schriftzugs
// (z. B. „Tipwin Rietberg" → [Logo] Rietberg). tone="dark" für dunkle
// Hintergründe (weisses Logo), tone="light" für helle (dunkles Logo).
export default function LocationName({ name, tone = "dark", className = "" }) {
  const logo = tone === "dark" ? "/brand/tipwin-logo.png" : "/brand/tipwin-logo-dark.png";
  if (name && name.startsWith("Tipwin ")) {
    return (
      <span className={className} data-testid="location-brand-name">
        <img
          src={logo}
          alt="Tipwin"
          width="350"
          height="107"
          className="mr-[0.35em] inline-block h-[1.05em] w-auto align-[-0.15em]"
        />
        {name.slice(7)}
      </span>
    );
  }
  return <span className={className} data-testid="location-brand-name">{name}</span>;
}
